// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav--2Sg9U","line":"line--1G6b_","pages":"pages--37kbg","page":"page--2Ytuh","active":"active--TRlz8","active-transition":"active-transition--3e4z1"};